<template lang="html">
    <div class="page" id="proOffers">
        <header class="pageHeader">
            <fade-image src="assets/headers/offers.png" />
        </header>

        <div id="scroller" class="small">
            <div class="pageHeaderIntro">
                <h1>Offers</h1>
                <img class="icon" src="~@/assets/icons/headers/offers.svg" />
            </div>

            <empty-placeholder class="mt10" v-if="Object.keys(offers).length == 0">
                TIP: Add a category first and assign your offers to them when they are created.
                Players are notified of new offers automatically when they are added.
            </empty-placeholder>

            <div v-if="!$store.state.offersLoaded">
                <h2 class="title">Loading offers...</h2>
                <pre-loader-item v-for="n in 5" :key="n" />
            </div>

            <div v-else>
                <div v-for="(category, key) in offers" :key="key">
                    <h2 class="title cat_title">{{ key }}:</h2>
                    <ul class="offers">
                        <li v-for="offer in category" :key="offer.id">
                            <router-link
                                class="button greenLight"
                                :to="{ name: 'proOffer', params: { id: offer.id } }"
                            >
                                {{ offer.title }}
                                <img class="arrow" src="@/assets/arrow-right-white.svg" alt="" />
                            </router-link>
                        </li>
                    </ul>
                </div>
            </div>

            <router-link class="button dark" :to="{ name: 'proOffersNew' }">
                Add new offer
                <plus-icon class="icon" />
            </router-link>

            <router-link class="button dark mb" :to="{ name: 'proOffersCategories' }">
                Edit categories
                <img class="arrow" src="@/assets/arrow-right-white-2.svg" alt="" />
            </router-link>
        </div>
    </div>
</template>

<script>
import EmptyPlaceholder from "@/components/App/empty-placeholder";
import PreLoaderItem from "@/components/App/Pre-loader-item";
import FadeImage from "@/components/App/fade-image";
import { PlusIcon } from "vue-feather-icons";
export default {
    name: "offers",
    components: { EmptyPlaceholder, PreLoaderItem, FadeImage, PlusIcon },
    computed: {
        offers() {
            // Order categories by category name
            return this.$store.state.offers.reduce(function (rv, x) {
                (rv[x["category"]["name"]] = rv[x["category"]["name"]] || []).push(x);
                return rv;
            }, {});
        },
    },
    created() {
        this.getOffers();
    },
    methods: {
        getOffers() {
            this.$store.dispatch("getOffers");
        },
    },
};
</script>

<style lang="scss" scoped>
#proOffers {
    .pageHeaderIntro {
        .icon {
            width: auto;
            margin-top: -10px;
        }
    }
    .button {
        margin-bottom: 10px;
        &.mb {
            margin-bottom: 20px;
        }
    }
    .arrow {
        float: right;
        margin-top: 1px;
        margin-right: 1px;
    }

    .offers {
        margin-bottom: 30px;
    }
    .cat_title {
        margin-bottom: 20px;
    }
}
</style>
